import { createSlice } from "@reduxjs/toolkit";

export type UserDataState = {
  isUnauthorized: boolean;
};

const initialState: UserDataState = {
  isUnauthorized: false,
};

export const userDataSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    setUnauthorized: (state) => {
      state.isUnauthorized = true;
    },
    resetUserData: () => initialState,
  },
});

export const { setUnauthorized, resetUserData } = userDataSlice.actions;

export default userDataSlice.reducer;
